{
    "common": {
        "mon": "Hé",
        "tue": "Ke",
        "wed": "Sze",
        "thu": "Csü",
        "fri": "Pé",
        "sat": "Szo",
        "sun": "Vas",
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Már",
        "apr": "Ápr",        
        "jun": "Jún",
        "jul": "Júl",
        "aug": "Aug",
        "sep": "Szep",
        "oct": "Okt",
        "nov": "Nov",
        "dec": "Dec",
        "january": "Január",
        "february": "Február",
        "march": "Március",
        "april": "Április",
        "may": "Május",
        "june": "Június",
        "july": "Július",
        "august": "Augusztus", 
        "september": "Szeptember",
        "october": "Október",
        "november": "November",
        "december": "December",
        "checkin": "Bejelentkezés",
        "checkout": "Kijelentkezés",
        "room": "Szoba",
        "rooms": "Szobák",
        "adult": "Felnőtt",
        "adults": "Felnőttek",
        "edit": "Szerkesztés",
        "editCap": "SZERKESZTÉS",
        "delete": "Törlés",
        "deleteCap": "TÖRLÉS",
        "localTime": "Helyi Idő",
        "back": "VISSZA",
        "home": "FŐOLDAL",
        "yes": "IGEN",
        "no": "NEM",
        "left": "Maradt",
        "hour": "Óra",
        "hours": "Órák",
        "night": "éjszaka",
        "nights": "éjszakák",
        "for": "részére",
        "why": "Miért",
        "get": "Kapj",
        "more": "Több",
        "agree": "ELFOGADOM",
        "disagree": "ELUTASÍTOM",
        "basedOn": "alapján",
        "error": "Hiba történt, kérjük próbálja újra később",
        "error2": "Sikertelen, próbálja újra!",
        "error3": "Hiba történt!!",
        "error4": "Hiba történt!! Kérjük próbálja újra",
        "error5": "Sajnáljuk!! Hiba történt. Kérjük próbálja újra később.",
        "hi": "Szia",
        "to": "ig",
        "free": "Ingyenes",
        "per": "Per",
        "at": "-kor",
        "day": "Nap",
        "days": "Napok",
        "time": "Idő",
        "of": "-ból",
        "photo": "Fotó",
        "photos": "Fotók",
        "done": "Kész",
        "fullStay": "Teljes Tartózkodás",
        "date": "Dátum",
        "and": "és",
        "bookingDetail": "Foglalási Részletek",
        "Back": "Vissza",
        "Home": "Főoldal"
    },
    "userPopup": {
        "myAccount": "Fiókom",
        "welcome": "Üdvözöljük",
        "user": "Felhasználó",
        "findMyBookings": "FOGLALÁSAIM KERESÉSE",
        "viewProfile": "PROFIL MEGTEKINTÉSE",
        "makeAReservarion": "FOGLALÁS KÉSZÍTÉSE",
        "logout": "KIJELENTKEZÉS",
        "loginCap": "BEJELENTKEZÉS",
        "login": "Bejelentkezés",
        "invalidCredentials": "Érvénytelen hitelesítő adatok",
        "invalidEmail": "Érvénytelen e-mail",
        "passwordIsRequired": "Jelszó megadása kötelező",
        "minChar8": "minimum 8 karakter",
        "tooShort": "Túl Rövid!",
        "tooLong": "Túl Hosszú!",
        "required": "Kötelező",
        "emailInvalid": "Adjon meg egy érvényes e-mail címet",
        "passwordInvalid": "Adjon meg egy érvényes jelszót",
        "phNumInvalid": "A telefonszám nem érvényes",
        "signupCap": "REGISZTRÁCIÓ",
        "signup": "Regisztráció",
        "verifyText": "Igazolja, hogy Ön az",
        "verifyText2": "Ellenőrző kódot küldtünk az e-mail címére",
        "verificationCode": "Ellenőrző Kód",
        "didNotReceiveEmail": "Nem kapta meg az e-mailt",
        "clickToResend": "Kattintson az újraküldéshez",
        "verifyAndSignIn": "Ellenőrzés és Bejelentkezés",
        "otpSentSuccessfully": "OTP sikeresen elküldve",
        "somethingWentWrong": "Valami hiba történt, kérjük próbálja újra",
        "otpError": "Kérjük, adjon meg egy érvényes számot",
        "otpError2": "Kérjük, csak számokat adjon meg",
        "otpError3": "Hibás OTP, kérjük próbálja újra",
        "otpError4": "OTP lejárt, kattintson az Újraküldésre",
        "otpError5": "Kérjük, próbálja újra",
        "forgetPassword": "Elfelejtett Jelszó",
        "submitError": "A felhasználó nem létezik!",
        "userExistError": "A Felhasználó Már Létezik",
        "checkYourEmail": "Ellenőrizze e-mailjét",
        "passwordResetLinkSent": "Jelszó-visszaállítási linket küldtünk a következő címre",
        "noWorriesResetInstructions": "Ne aggódjon, elküldjük a visszaállítási utasításokat.",
        "enterYourEmail": "Adja meg e-mail címét",
        "resetMyPassword": "JELSZAVAM VISSZAÁLLÍTÁSA",
        "setANewPassword": "Új jelszó beállítása",
        "newPassword": "Új Jelszó",
        "confirmPassword": "Jelszó Megerősítése",
        "confirmPasswordError": "A jelszavaknak egyezniük kell",
        "backToLogin": "Vissza a Bejelentkezéshez",
        "dontHaveAccount": "Nincs fiókja?",
        "alreadyHaveAccount": "Már van fiókja?",
        "memberDiscount1": "Kap",
        "memberDiscount2": "örökös tagi kedvezményt.",
        "discount1": "Kezelje összes foglalását egy helyen.",
        "discount2": "Regisztráljon személyre szabott ajánlásokért és egyedi élményekért!!",
        "discount3": "Csatlakozzon elégedett vendégeink közösségéhez és kezdje el tervezni tartózkodását.",
        "leftGridText1": "Kezelje összes foglalását egy helyen",
        "leftGridText2": "Regisztráljon személyre szabott ajánlásokért és egyedi élményekért!!",
        "leftGridText3": "Csatlakozzon elégedett vendégeink közösségéhez és kezdje el tervezni tartózkodását",
        "gridDiscountText1": "tagi kedvezmény",
        "gridDiscountText2": "örökre kiválasztott szállásokon",
        "gridDiscountText3": "Jelentkezzen be személyre szabott élményért örökre",
        "gridDiscountText4": "Kapjon Exkluzív Tagi Előnyöket",
        "findBookingError": "Az e-mail címe és a foglalási azonosító nem egyezik",
        "verifyAndConfirmBooking": "Foglalás ellenőrzése és megerősítése",
        "confirmEmailText": "Ellenőrző kódot küldtünk az e-mail címére",
        "enterCodeText": "Kérjük, adja meg az Önnek küldött ellenőrző kódot",
        "didNotRecieveEmail": "Nem kapta meg az e-mailt?",
        "changeEmailText": "Kattintson ide az e-mail cím módosításához",
        "verifyAndConfirm": "Ellenőrzés és Megerősítés",
        "verified": "ELLENŐRIZVE",
        "bookingExpired": "Foglalás Lejárt",
        "bookingExpiredText": "Sajnáljuk, az Ön által használt foglalási azonosító lejárt",
        "backToFindingBooking": "Vissza a Foglalás Kereséséhez",
        "findMyBooking": "Foglalásaim Keresése",
        "bookingEmail": "Foglalási E-mail",
        "reservationId": "Foglalási Azonosító",
        "findBooking": "FOGLALÁS KERESÉSE",
        "abandonmentCartDoneText1": "Köszönjük!",
        "abandonmentCartDoneText2": "A kosár részleteit elküldtük az e-mailre. Bármikor folytathatja foglalását.",
        "Recommended Currencies": "Ajánlott Pénznemek",
        "All currencies": "Összes pénznem",
        "thisIsRequiredField": "Ez egy kötelező mező"
    },
    "widget": {
        "destination": "Úti Cél",
        "enterDestination": "Adja Meg az Úti Célt",
        "guests": "Vendégek",
        "guest": "Vendég",
        "nationality": "Nemzetiség",
        "selectNationality": "Válasszon nemzetiséget",
        "nationalityIsRequired": "A nemzetiség megadása kötelező",
        "selectedRate": "Speciális ár",
        "search": "Keresés",
        "ages": "Életkor",
        "orAbove": "Vagy Idősebb",
        "child": "Gyermek",
        "children": "Gyermekek",
        "addAnotherRoom": "Másik Szoba Hozzáadása",
        "removeRoom": "Szoba Eltávolítása",
        "property": "Szállás",
        "city": "Város",
        "country": "Ország",
        "bookNow": "Foglalás Most",
        "overnightStay": "Éjszakai Tartózkodás",
        "dayUse": "Nappali Használat",
        "destinationIsRequired": "Úti cél megadása kötelező",
        "checkInIsRequired": "Bejelentkezési dátum megadása kötelező",
        "checkOutIsRequired": "Kijelentkezési dátum megadása kötelező",
        "noLocationFound": "Nem Található Helyszín",
        "soldOut": "Elfogyott",
        "highDemand": "Nagy Kereslet",
        "dates": "Dátumok",
        "allRates": "Minden ár a következő pénznemben",
        "K": "E",
        "M": "M",
        "sameDayCheckout": "Azonos napi kijelentkezés"
    },
    "promotion": {
        "headingText": "Fontos Információ",
        "regularRate": "Nincs",
        "seniorCitizen": "Nyugdíjas Ár",
        "agencyRate": "Ügynökségi Ár",
        "caaRate": "CAA/AAA Ár",
        "corporateRate": "Vállalati Ár",
        "governmentRate": "Kormányzati/Katonai Ár",
        "promotionalSpecialRate": "Promóciós/Különleges Ár",
        "regularRateDescription": "Nincs alkalmazott promóció.",
        "seniorCitizenRateDescription": "Ez egy kedvezményes szállodai ár, amely széles körben elérhető idősebb felnőttek számára, általában 60 éves vagy idősebb.",
        "agencyRateDescription": "Ez egy kedvezményes szállodai ár, amely csak bizonyos utazási irodákon keresztül érhető el a partnerség és együttműködés előmozdítása érdekében.",
        "caaRateDescription": "Ez egy speciális szállodai ár az AAA vagy CAA tagok számára, exkluzív megtakarításokért.",
        "corporateRateDescription": "Ez egy kedvezményes szállodai ár üzleti utazók számára, amelyet általában a szálloda és a vállalat egyeztet.",
        "governmentRateDescription": "Ez az árterv specifikus kedvezményeket kínál kormányzati/katonai személyzet számára szállodai szoba foglalásához.",
        "contentSeniorCitizen": "Születési dátum igazolása kötelező a bejelentkezéskor. A megfelelő igazolvány hiányában az érvényes díjakat számítjuk fel.",
        "contentAgencyRate": "Kérjük, érkezéskor hozza magával a foglalási visszaigazolást és a személyi igazolványt. Ezek hiányában a normál árak kerülnek alkalmazásra.",
        "contentPromotionalSpecialRate": "Ez egy korlátozott ideig elérhető kedvezményes szállodai ár, gyakran meghatározott eseményekhez, évszakokhoz vagy marketingkampányokhoz kapcsolódik.",
        "contentCaaRate": "Kérjük, bejelentkezéskor hozza magával CAA tagsági kártyáját vagy megfelelő igazolványát. A megfelelő igazolvány hiányában az érvényes díjakat számítjuk fel.",
        "contentCorporateRate": "Vállalati igazolvány vagy más hivatalos dokumentáció szükséges a bejelentkezéskor. A megfelelő igazolás hiányában az érvényes díjakat számítjuk fel.",
        "contentGovernmentRate": "Érvényes kormányzati vagy katonai igazolvány bemutatása kötelező a bejelentkezéskor. A szükséges igazolvány hiányában a normál árak kerülnek felszámításra.",
        "CORP": "VÁLL",
        "AGEN": "ÜGYV",
        "PROM": "PROM",
        "apply": "ALKALMAZ",
        "Offer Code": "Ajánlati Kód",
        "Agency Code": "Ügynökségi Kód",
        "Corporate Code": "Vállalati Kód",
        "All-Access Rate": "Teljes Hozzáférésű Ár",
        "errorCode": "Ez a kód nem érvényes"
    }
}
